(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wishlist-products"] && !Shopify.designMode) return;
  try {
    
  class WishlistProductsRenderer {
    constructor() {
      this.storageKey = 'shopify-wishlist';
      this.oldStorageKey = 'onhow-wishlist'; // For migration
      this.container = document.getElementById('wishlist-products-grid');
      this.emptyState = document.querySelector('.wishlist-empty-state');
      this.init();
    }

    init() {
      // Migrate data from old storage key if needed
      this.migrateOldData();

      this.loadWishlistProducts();

      // Listen for wishlist updates
      window.addEventListener('wishlist:updated', () => {
        this.loadWishlistProducts();
      });

      // Also listen for storage changes from other tabs
      window.addEventListener('storage', (e) => {
        if (e.key === this.storageKey || e.key === this.oldStorageKey) {
          this.loadWishlistProducts();
        }
      });
    }

    migrateOldData() {
      try {
        const oldData = localStorage.getItem(this.oldStorageKey);
        const newData = localStorage.getItem(this.storageKey);

        // If old data exists and new data doesn't, migrate
        if (oldData && !newData) {
          localStorage.setItem(this.storageKey, oldData);
          console.log('Migrated wishlist data from old storage key');
        }

        // If both exist, merge them
        if (oldData && newData) {
          const oldWishlist = JSON.parse(oldData);
          const newWishlist = JSON.parse(newData);

          // Merge without duplicates based on title
          const merged = [...newWishlist];
          oldWishlist.forEach(oldItem => {
            if (!merged.some(item => item.title === oldItem.title)) {
              merged.push(oldItem);
            }
          });

          localStorage.setItem(this.storageKey, JSON.stringify(merged));
          console.log('Merged wishlist data from both storage keys');
        }
      } catch (error) {
        console.error('Error migrating wishlist data:', error);
      }
    }

    getWishlist() {
      try {
        // Try new storage key first
        const wishlist = JSON.parse(localStorage.getItem(this.storageKey) || '[]');

        // If empty, check old storage key as fallback
        if (wishlist.length === 0) {
          const oldWishlist = JSON.parse(localStorage.getItem(this.oldStorageKey) || '[]');
          if (oldWishlist.length > 0) {
            // Migrate and return
            localStorage.setItem(this.storageKey, JSON.stringify(oldWishlist));
            return oldWishlist;
          }
        }

        return wishlist;
      } catch {
        return [];
      }
    }

    async loadWishlistProducts() {
      const wishlist = this.getWishlist();

      if (wishlist.length === 0) {
        this.showEmptyState();
        return;
      }

      this.hideEmptyState();

      // Extract product handles from URLs
      const productHandles = wishlist.map(item => {
        const url = item.url || '';
        const match = url.match(/\/products\/([^?/#]+)/);
        return match ? match[1] : null;
      }).filter(Boolean);

      if (productHandles.length === 0) {
        this.showEmptyState();
        return;
      }

      try {
        // Fetch product data for each handle
        const productPromises = productHandles.map(handle =>
          fetch(`/products/${handle}.js`)
            .then(res => {
              if (!res.ok) throw new Error('Product not found');
              return res.json();
            })
            .catch(() => null)
        );

        const products = await Promise.all(productPromises);
        const validProducts = products.filter(p => p !== null);

        if (validProducts.length === 0) {
          this.showEmptyState();
          return;
        }

        this.renderProducts(validProducts);
      } catch (error) {
        console.error('Error loading wishlist products:', error);
        this.showEmptyState();
      }
    }

    renderProducts(products) {
      const productsHTML = products.map(product => this.createProductCard(product)).join('');
      this.container.innerHTML = productsHTML;

      // Attach remove button listeners
      this.attachRemoveListeners();
    }

    createProductCard(product) {
      const image = product.featured_image || (product.images && product.images[0]) || '';
      const price = this.formatMoney(product.price);
      const compareAtPrice = product.compare_at_price > product.price
        ? this.formatMoney(product.compare_at_price)
        : null;

      return `
        <div class="wishlist-product-card">
          <button
            class="wishlist-remove-button"
            data-product-title="${this.escapeHtml(product.title)}"
            aria-label="Remove ${this.escapeHtml(product.title)} from wishlist"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M18 6L6 18M6 6l12 12"></path>
            </svg>
          </button>

          <a href="/products/${product.handle}" class="wishlist-product-card__image">
            <img src="${image}" alt="${this.escapeHtml(product.title)}" loading="lazy">
          </a>

          <div class="wishlist-product-card__content">
            <h3 class="wishlist-product-card__title">
              <a href="/products/${product.handle}">${this.escapeHtml(product.title)}</a>
            </h3>
            <div class="wishlist-product-card__price">
              ${compareAtPrice ? `<span class="price--compare">${compareAtPrice}</span>` : ''}
              <span class="price--current">${price}</span>
            </div>
            <a href="/products/${product.handle}" class="button button--secondary button--small">
              View Product
            </a>
          </div>
        </div>
      `;
    }

    attachRemoveListeners() {
      const removeButtons = this.container.querySelectorAll('.wishlist-remove-button');
      removeButtons.forEach(button => {
        button.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          const productTitle = button.dataset.productTitle;
          this.removeFromWishlist(productTitle);
        });
      });
    }

    removeFromWishlist(productTitle) {
      let wishlist = this.getWishlist();
      wishlist = wishlist.filter(item => item.title !== productTitle);
      localStorage.setItem(this.storageKey, JSON.stringify(wishlist));

      // Dispatch event for other components
      window.dispatchEvent(new CustomEvent('wishlist:updated', {
        detail: { wishlist }
      }));

      // Reload products
      this.loadWishlistProducts();
    }

    formatMoney(cents) {
      const amount = cents / 100;
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(amount);
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }

    showEmptyState() {
      this.container.style.display = 'none';
      this.emptyState.style.display = 'block';
    }

    hideEmptyState() {
      this.container.style.display = 'grid';
      this.emptyState.style.display = 'none';
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new WishlistProductsRenderer());
  } else {
    new WishlistProductsRenderer();
  }

  } catch(e) { console.error(e); }
})();
})();
